<app-bar [title]="currentTitle"></app-bar>
<section>
  <div class="content-wrapper">
    <app-sidebar
      *ngIf="ui.canShowSidebar$ | async"
      [navigation]="navigation"
      [hovered]="layoutService.hovered.value"
      [opened]="!layoutService.isMobile || (layoutService.isMobile &&layoutService.hovered.value)"
      [mode]="layoutService.isMobile ?'over':'side'" 
      (hoveredChanged)="layoutService.hovered.next($event)"
    >
      <ng-container fuseVerticalNavigationContentHeader>

        <div class="w-full flex justify-between">
          <i class="ri-menu-fold-line" 
          style="font-size: 1.5rem; cursor: pointer" 
          (click)="toggleNavigation()"></i>
        </div>
      </ng-container>
      <ng-container fuseVerticalNavigationFooter>
        v {{ appVersion }}
      </ng-container>
    </app-sidebar>
    <div id="menu-content">
      <app-header *ngIf="ui.canShowSidebar$ | async" class="hidden sm:block"></app-header>
      <app-avisos></app-avisos>
      <div class="outlet" cdkScrollable>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</section>

<app-columns-drawer></app-columns-drawer>
<app-filters-drawer></app-filters-drawer>
<app-content-drawer></app-content-drawer>
<app-custom-drawer></app-custom-drawer>
